import React from "react";

import Button, { ButtonProps } from "../buttons/Button";

interface Props extends Pick<ButtonProps, "color"> {
  isLoading?: boolean;
  dismissLabel?: string;
  onDismiss?: (event: React.MouseEvent<Element, MouseEvent>) => void;
}

const DismissButton: React.FC<React.PropsWithChildren<Props>> = (props) => {
  return (
    <>
      <Button title={props.dismissLabel || "Close"} onClick={props.onDismiss}>
        {props.dismissLabel || "Close"}
      </Button>
    </>
  );
};

export default DismissButton;
